import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './design-system/css-variables.css';
import GuestApp from './GuestApp';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { ThemeProvider } from './design-system';
import { installApiTelemetry } from './utils/apiTelemetry';

installApiTelemetry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <GuestApp />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
serviceWorkerRegistration.register();
serviceWorkerRegistration.sendMessageToServiceWorker({
  type: 'SET_OFFLINE_TILE_CACHING',
  enabled: false,
});
